<template>
    <div>
        <!-- <div class="no-display">
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar no-display">
                    <v-toolbar-title>Bank Advice</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row class="no-display" justify="center" dense>
                    <v-col cols="12" sm="2" md="2">
                        <p><v-icon color="error">*</v-icon><b>Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="calendar_year"
                            :items="calendar_year_list" @change="getSalaryMonths()" item-text="name" item-value="id"
                            label="Year" outlined persistent-hint hint="Please Select Year" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="this.salary_month_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Salary Month</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="salary_month"
                            :items="salary_month_list" item-text="sal_mon" return-object
                            @change="getPartialSalaryDetails()" label="Month" outlined persistent-hint
                            hint="Please Select Month" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list!='' && partial_salary_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Partial Salary Installment</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="partial_salary"
                            :items="partial_salary_list" item-text="ps_name" item-value="ps_id"
                            label="Partial Salary Installment" outlined persistent-hint
                            hint="Please Select Partial Salary Installment" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="this.salary_month_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Employee Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
                            :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined
                            persistent-hint hint="Please Select Employee Type" />
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Employee Section</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee_section"
                            :items="employee_section_list" item-text="name" item-value="id" label="Employee Section"
                            outlined persistent-hint hint="Please Select Employee Section" multiple />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Employee Shift</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="shift"
                            :items="employee_shift_list" item-text="name" item-value="id" label="Employee Shift"
                            outlined persistent-hint hint="Please Select Employee Shift" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Employee Bank Organization</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="bank_org"
                            :items="bank_org_list_all" item-text="name" item-value="id"
                            label="Employee Bank Organization" outlined persistent-hint
                            hint="Please Select Employee Bank Organization" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.salary_month_list!=''">
                        <p><v-icon color="error">*</v-icon><b>Organization Bank</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="bank_org_show"
                            :items="bank_org_list" item-text="name" return-object label="Organization Bank" outlined
                            persistent-hint hint="Please Select Organization Bank" />
                    </v-col>
                    <v-col cols="12" md="3" sm="3" class="mt-4">
                        <v-btn rounded class="button mt-6" v-if="salary_month" @click="getAdviceReport()"
                            :loading="loader">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-btn tile color="warning" outlined class="ma-2 no-display" @click="print()"
                v-if="emp_salary_reg_detail!=''"><v-icon left>mdi-printer</v-icon>Print <v-icon right></v-icon></v-btn>
            <!-- <div id="printdiv"> -->

            <v-btn rounded class="ma-2 no-display" color="success" v-if="emp_salary_reg_detail!=''" outlined
                @click="fnExcelReport('my-table-id', 'BankAdvise')"><v-icon
                    color="success">mdi-export</v-icon>Export</v-btn>
                    <div id="print-area" v-if="emp_salary_reg_detail != ''">
            <v-simple-table class="report-table" id="my-table-id" fixed-header dense v-if="emp_salary_reg_detail!=''">
                <thead>
                    <tr style="page-break-inside: avoid; ">
                        <td class="msg" colspan="7">
                            <div v-if="org_basic_data">
                                <v-row dense justify="center">
                                    <v-col cols="10" sm="2" md="2" v-if="org_basic_data.school_logo">
                                        <img v-if="org_id!='wws'" height="150" width="150"
                                            :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                    </v-col>
                                    <v-col cols="10" sm="8" md="8">
                                        <center>
                                            <h2>
                                                <strong>{{ org_basic_data.trust_name }}</strong>
                                            </h2>
                                            <h1>
                                                <strong>{{ org_basic_data.school_name }} </strong>
                                            </h1>
                                            <span>{{ org_basic_data.address }}</span> <br />
                                            <!-- <span v-if="org_basic_data.phone">Phone : {{ org_basic_data.phone }}, </span>
                                            <br />
                                            <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }},</span>

                                            <span v-if="org_basic_data.website">Website : {{ org_basic_data.website }}
                                            </span> -->
                                            
                                            <!-- <br /> -->
                                        </center>
                                        <table class="print-header-table">
    <tr>
        <td>
            <span v-if="org_basic_data.phone">
                Phone : {{ org_basic_data.phone }},
            </span>
            <span v-if="org_basic_data.email">
                Email : {{ org_basic_data.email }},
            </span>
            <span v-if="org_basic_data.website">
                Website : {{ org_basic_data.website }}
            </span>
        </td>
    </tr>
</table>

                                    </v-col>
                                    <v-col cols="10" sm="2" md="2" v-if="org_basic_data.trust_logo" align="center">
                                        <img v-if="org_id!='wws'" height="150" width="150"
                                            :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                                    </v-col>
                                </v-row>
                            </div>
                            <hr>
                            <center>
                                <h2>
                                    <b>
                                        Bank Advice of {{salary_month.sal_mon}}
                                    </b>
                                </h2>
                            </center>
                            <p
                                style="padding-left: 40px; text-align: justify !important; margin-right: 5% !important; font-size: 18px !important;">
                                To,<br />
                                The Manager,<br />
                                {{bank_org_show.name}}
                                <!-- ${salarybankOrganization?.erpbankname?.name}<br> -->
                                <br><br>
                                <span v-if="org_id!='wws'">
                                    <center style="font-size: 18px;"></center>Subject : Salary Advice For
                                    {{salary_month.sal_mon}} </center>
                                </span>
                                <span v-else style="font-size: 18px;">Subject : Transfer Salary For The Month Of
                                    {{salary_month.sal_mon}}</span>

                            </p>
                            <p v-if="org_id!='wws'"
                                style="padding-left: 40px; text-align: justify !important; margin-right: 5% !important; font-size: 18px !important;">
                                Sir/Madam,<br />
                                Hereby sending Cheque No___________________________ Dated_____________ of Rs.
                                {{total_net_salary}}/- only towards salary. Kindly acknowledge the receipt and debit net
                                amount to salary payment Acc.
                                No._______________________ and credit the same to the individual account of employees as
                                per the list enclosed.
                                <br />
                                Thanking you.
                                <br />
                            </p>
                            <p v-else
                                style="padding-left: 40px; text-align: justify !important; margin-right: 5% !important; font-size: 18px !important;">
                                Sir/Madam,<br />
                                Kindly transfer amount of {{total_net_salary}}/-- ({{total_net_salary_in_words}}) to
                                following account numbers against Cheque No___________________________
                                Dated_____________.
                                <br />
                                Thanking you.
                                <br />
                            </p>
                            <p style="text-align:right;padding-right:50px;font-size:18px;">Your's Truly,</p>
                        </td>
                    </tr>
                    <tr>
                        <td align="center">Sr. No.</td>
                        <td align="center">Employee</td>
                        <td align="center">Bank Name</td>
                        <td align="center">Account Number</td>
                        <td align="center">Ifsc Code</td>
                        <td align="center">Net Salary</td>
                        <td class="text-center">Remarks</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(s, index) in emp_salary_reg_detail" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td class="text-center" v-if="org_id!='wws'">{{ s.emp_name }}</td>
                        <td class="text-center" v-else>{{ s.empname }}</td>
                        <td class="text-center">{{ s.emp_bank }}</td>
                        <td class="text-center">{{ s.emp_bank_ac_no }}</td>
                        <td class="text-center">{{ s.emp_ifsc_code }}</td>
                        <td class="text-center">
                            <center>{{ s.net_salary }}</center>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="4"></td>
                        <td class="text-center"><strong>Total </strong></td>
                        <td class="text-center">{{total_net_salary}}</td>
                        <td></td>
                    </tr>
                </tbody>
            </v-simple-table>
            </div>

        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            Breadcrumbs,
        },
        data: () => ({
            selected: [],
            extraBreadcrumbItems: [


            ],
            breadcrumbClass: "breadcrumb-style1",
            loader: false,
            radios: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            title: "",
            description: "",
            search: "",
            calendar_year_list: [],
            calendar_year: "",
            salary_month_list: [],
            salary_month: "",
            employee_type_list: [],
            employee_type: "",
            employee_section_list: [],
            employee_shift_list: [],
            employee_section: [],
            shift: null,
            bank_org_list: [],
            bank_org: null,
            bank_org_list_all: [],
            bank_org_show: null,
            total_net_salary: null,
            total_net_salary_in_words: null,
            emp_salary_reg_detail: [],
            partial_salary_list: [],
            partial_salary: null,
            org_basic_data: [],
            org_id: null,
        }),
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },


            // print() {
            //     this.$store.state.drawer = false;
            //     let that = this;
            //     window.onafterprint = function () {
            //         that.$store.state.drawer = true;
            //     };
            //     setTimeout(function () {
            //         window.print();
            //     }, 100);
            // },
            print() {
    this.$store.state.drawer = false;
    setTimeout(() => {
        window.print();
        // Restore drawer after print dialog closes
        setTimeout(() => {
            this.$store.state.drawer = true;
        }, 500);
    }, 200);
},
            getPartialSalaryDetails() {
                // alert("in method")
                // console.log(this.salary_month.partial_salary_list)
                this.partial_salary_list = this.salary_month.partial_salary_list;
                if (this.partial_salary_list == "") {
                    // alert("No Installments available for partial salary!!!");
                    this.partial_salary_list = [];
                }
            },
            async getAdviceReport() {
                if (this.employee_section.length == 0) {
                    this.showSnackbar("red", "Please Select Section");
                    return
                }
                const data = {
                    sal_month: this.salary_month.id,
                    employee_type: this.employee_type,
                    section: this.employee_section,
                    shift: this.shift,
                    bank_org: this.bank_org,
                    partial_salary: this.partial_salary,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/Payroll/fetchBankAdvice", data);
                    if (res.data.flag == "YES") {
                        this.total_net_salary = res.data.total_net_salary;
                        this.total_net_salary_in_words = res.data.total_net_salary_in_words
                        this.emp_salary_reg_detail = res.data.emp_salary_reg_detail;
                        this.org_basic_data = res.data.org_basic_data;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.fmsg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            setNull() {
                (this.salary_month_list = []), (this.salary_month = "");
                this.partial_salary_list = [];
                this.partial_salary = null;
            },
            getSalaryMonths() {
                this.setNull();
                const data = {
                    year: this.calendar_year,
                };
                this.overlay = true;
                axios
                    .post("/Payroll/getSalaryMonth", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.salary_month_list = res.data.sal_month_list;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            onLoad() {
                axios
                    .post("EmployeeBiometric/getPayrollInfo")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            this.calendar_year_list = res.data.calendar_year_list;
                            this.employee_type_list = res.data.employee_type_list;
                            this.employee_section_list = res.data.employee_section_list;
                            this.employee_shift_list = res.data.employee_shift_list;
                            this.employee_type = this.employee_type_list[0].id;
                            //  this.employee_section = this.employee_section_list[0].id;
                            this.bank_org_list = res.data.bank_org_list;
                            this.bank_org_list_all = res.data.bank_org_list_all;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        watch: {},
    };
</script>
<style scoped>
    /* .v-text-field{
      width: 80px;
} */
    thead {
        font-weight: bold !important;
    }

    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        /* font-size: small; */
    }

    tr,
    tbody {
        /* border-bottom: 1px solid black; */
        border: 1px solid black;
        /* font-size: small; */
    }

    /* td {
        font-size: small;
    } */
    .msg {
        font-weight: Normal !important;
    }

    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
.print-header-table,
    .print-header-table tr,
    .print-header-table td {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .print-header-table {
        width: 100% !important;
        text-align: center !important;
        border-collapse: collapse !important;
        /* margin-top: 4px !important; */
    }

    .print-header-table td {
        padding: 0 !important;
        font-size: 14px !important;
        white-space: nowrap !important;
        line-height: 1.2 !important;
    }

    .print-header-table span {
        display: inline !important;
        white-space: nowrap !important;
    }
    @media print {
        ::v-deep table.print-header-table,
    ::v-deep table.print-header-table tr,
    ::v-deep table.print-header-table td {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }

    ::v-deep table.print-header-table {
        width: 100% !important;
        text-align: center !important;
        border-collapse: collapse !important;
        /* margin-top: 4px !important; */
    }

    ::v-deep table.print-header-table td {
        padding: 0 !important;
        font-size: 12px !important;
        white-space: nowrap !important;
        line-height: 1.2 !important;
    }

    ::v-deep table.print-header-table span {
        display: inline !important;
        white-space: nowrap !important;
    }
    /* Hide everything except the report */
    body * {
        visibility: hidden;
    }
    #print-area, #print-area * {
        visibility: visible;
    }
    #print-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }

    /* Page setup */
    @page {
        size: A4 portrait;
        margin: 15mm 10mm 15mm 10mm !important;
    }

    /* Ensure table fits */
    .report-table {
        width: 100% !important;
        font-size: 14px !important;
        page-break-inside: avoid;
    }

    .report-table td,
    .report-table th {
        font-size: 13px !important;
        padding: 6px 4px !important;
        border: 1px solid #000 !important;
    }

    .msg {
        font-size: 16px !important;
        line-height: 1.6 !important;
        text-align: justify;
        padding: 0 40px !important;
    }

    .schl-logo, .trust-logo {
        height: 100px !important;
        width: 100px !important;
    }

    /* Force full width */
    .v-container {
        padding: 0 !important;
        margin: 0 !important;
    }

    /* Remove Vuetify defaults */
    .v-card, .v-toolbar, .v-btn, .v-input, .no-display {
        display: none !important;
    }

    /* Only show print area */
    #print-area {
        display: block !important;
    }
}
</style>